export const SET_LISTING= 'PROTOCOLS/SET_LISTING'
export const SET_PAGINATOR= 'PROTOCOLS/SET_PAGINATOR'